export default __webpack_public_path__ + "static/media/newbie_project6.5662e1db.jpg";